// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import NewsLetterTable from './news-letter-table';
// assets
//

// ----------------------------------------------------------------------

export default function NewsLetter() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <NewsLetterTable />
        </Container >
    );
}
